@file:OptIn(InternalResourceApi::class)

package ifaandroid.feature.profile.log_period.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.feature.profile.log_period.generated.resources/"

@delegate:ResourceContentHash(-1_395_752_828)
internal val Res.drawable.ic_calendar: DrawableResource by lazy {
      DrawableResource("drawable:ic_calendar", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_calendar.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_calendar", Res.drawable.ic_calendar)
}
